import { createContext, useContext } from "react";

/** Only the store fixtures editor provides true: a break set on any other pog reaches no store's request. */
export const AisleBreakEditingContext = createContext(false);

export const useCanDeclareAisleBreaks = () => useContext(AisleBreakEditingContext);
